import { render, staticRenderFns } from "./UploadDocumentsModel.vue?vue&type=template&id=798acefd&"
import script from "./UploadDocumentsModel.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentsModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports